import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook for managing canonical URLs dynamically
 * @param {string} customUrl - Optional custom canonical URL. If not provided, uses current URL
 * @param {string} baseUrl - Optional base URL. If not provided, uses window.location.origin
 */
const useCanonicalUrl = (customUrl = null, baseUrl = null) => {
  const location = useLocation();

  useEffect(() => {
    // Remove any existing canonical link
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Create new canonical link
    const canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    
    // Determine the canonical URL
    let canonicalUrl;
    if (customUrl) {
      canonicalUrl = customUrl;
    } else {
      const origin = baseUrl || window.location.origin;
      canonicalUrl = origin + location.pathname;
    }
    
    canonical.setAttribute('href', canonicalUrl);
    document.head.appendChild(canonical);

    // Cleanup function to remove the canonical link when component unmounts
    return () => {
      const currentCanonical = document.querySelector('link[rel="canonical"]');
      if (currentCanonical && currentCanonical.getAttribute('href') === canonicalUrl) {
        currentCanonical.remove();
      }
    };
  }, [location.pathname, customUrl, baseUrl]);
};

export default useCanonicalUrl;